const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : undefined;
};

export default {
  session: () => getCookie('nc_s'),
  trackingCookie: () => getCookie('chumewe_user'),
  trackingSessCookie: () => getCookie('chumewe_sess'),
};
